import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import GlobalMeta from "../reusable/GlobalMeta";

import Layout1Section1 from "./Layout1Section1";
import Layout1Section2 from "./Layout1Section2";
import Layout1Section3 from "./Layout1Section3";
import Layout1Section4 from "./Layout1Section4";

import Layout2Section1 from "./Layout2Section1";
import Layout2Section2 from "./Layout2Section2";
import Layout2Section3 from "./Layout2Section3";
import Layout2Section4 from "./Layout2Section4";
import Layout2Section5 from "./Layout2Section5";

export default function LandingPage() {
  const { "*": slug } = useParams();
  const [pageData, setPageData] = useState();
  const [acfData, setAcfData] = useState();

  //Fetch post by slug
  const { isPending, isError, data, error } = useQuery(
    ["post", slug], //Query key and dependency
    () =>
      axios({
        //Query function
        method: "get",
        url:
          WP_API_Settings.endpoint +
          "wp/v2/theme_lp?slug=" +
          slug +
          "&_embed=true&acf_format=standard",
      })
  );

  useEffect(() => {
    if (data?.data) {
      setPageData(data.data[0]);
      if (data.data[0].acf) {
        setAcfData(data.data[0].acf);
      }
    }
  }, [data]);

  console.log(pageData);
  console.log(acfData);

  return (
    <>
      <GlobalMeta />
      {acfData?.layout && acfData?.layout == "layout_1" ? (
        <>
          <Layout1Section1
            acf={acfData?.layout_1?.section_1}
            logo={acfData?.layout_1?.header_logo?.url || null}
          />

          {acfData.layout_1?.section_2?.is_active ? (
            <Layout1Section2 acf={acfData.layout_1?.section_2} />
          ) : null}
          {acfData.layout_1?.section_3?.is_active ? (
            <Layout1Section3 acf={acfData.layout_1?.section_3} />
          ) : null}
          {acfData.layout_1?.section_4?.is_active ? (
            <Layout1Section4 acf={acfData.layout_1?.section_4} />
          ) : null}
        </>
      ) : null}

      {acfData?.layout && acfData?.layout == "layout_2" ? (
        <div id="lp-layout-2">
          <Layout2Section1
            acf={acfData.layout_2?.section_1}
            logo={acfData?.layout_2?.header_logo?.url || null}
          />

          {acfData.layout_2?.section_2?.is_active ? (
            <Layout2Section2
              acf={acfData.layout_2?.section_2}
              accent={
                acfData.layout_2?.section_3?.is_active &&
                acfData.layout_2?.section_3?.background_color
                  ? acfData.layout_2?.section_3?.background_color
                  : null
              }
            />
          ) : null}

          {acfData.layout_2?.section_3?.is_active ? (
            <Layout2Section3 acf={acfData.layout_2?.section_3} />
          ) : null}

          {acfData.layout_2?.section_4?.is_active ? (
            <Layout2Section4 acf={acfData.layout_2?.section_4} />
          ) : null}

          {acfData.layout_2?.section_5?.is_active ? (
            <Layout2Section5 acf={acfData.layout_2?.section_5} />
          ) : null}
        </div>
      ) : null}
    </>
  );
}
{
  /* <svg id="Layer_1" height="80" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1376.38 152">
<defs>
    <style>.cls-1{fill:#0969AF;}</style>
</defs>
<path class="cls-1" d="M0,40.87l67.29,9.37c56.92,9,170.75,26.58,284.59,15.6C465.71,54.7,579.54,14.64,693.38,3.5c113.83-11,227.66,6.55,341.5,15.61C1148.71,28,1262.54,28,1319.46,28h56.92V152H0Z"></path>
</svg> */
}
